import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/components/AssistantWidget.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/components/AuthProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/components/Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["GoogleAnalytics"] */ "/app/app/components/GoogleAnalytics.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LangSetter"] */ "/app/app/components/LangSetter.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LanguageProvider"] */ "/app/app/components/LanguageProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LocaleProvider"] */ "/app/app/components/LocaleProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["QueryProvider"] */ "/app/app/components/QueryProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["RouteTracker"] */ "/app/app/components/RouteTracker.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/components/SiteChrome.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["YandexMetrika"] */ "/app/app/components/YandexMetrika.tsx");
;
import(/* webpackMode: "eager" */ "/app/app/globals.css");
;
import(/* webpackMode: "eager" */ "/app/app/styles/glass-effects.css");
;
import(/* webpackMode: "eager" */ "/app/app/styles/zrobim-menu.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
